/* =========================================================
   TANNA – V37.3 SAFE

   Bazat pe V37.1 / V37.2

   FUNCȚIONALITĂȚI:
   - Pe factură/Admin: DOAR "NUME: ..."
     fără _tanna_bundle / _tanna_addon
   - Perechile rucsac <-> personalizare sunt salvate
     invizibil în cart.attributes
   - Dacă ștergi rucsacul -> se șterge personalizarea
   - Dacă ștergi personalizarea -> se șterge rucsacul
   - Suportă mai multe rucsacuri cu nume diferite
   - Fix Ella cart drawer după refresh dinamic
   - Fix pagina /cart:
       dacă scriptul șterge automat perechea,
       pagina se reîncarcă o singură dată pentru
       a afișa starea reală a coșului
   - Produsele normale / schimbările de cantitate NU
     declanșează reload pe /cart
   - Fără MutationObserver agresiv
   ========================================================= */

(() => {
  if (window.__tannaPersonalizareV373) return;
  window.__tannaPersonalizareV373 = true;

  const NAME_REGEX = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/;
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const escapeHtml = (str) =>
    String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  /* =========================================================
     CART HELPERS
     ========================================================= */

  async function getCart() {
    const r = await fetch("/cart.js", {
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
    });

    return await r.json();
  }

  async function setCartAttributes(attrs) {
    await fetch("/cart/update.js", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        attributes: attrs,
      }),
    });
  }

  function safeParseJSON(str, fallback) {
    try {
      const v = JSON.parse(str);
      return v ?? fallback;
    } catch (_) {
      return fallback;
    }
  }

  /* =========================================================
     PAIRS STORAGE

     tanna_pairs:
     [
       {
         mainKey: "...",
         addonKey: "..."
       }
     ]

     Este salvat în cart.attributes,
     nu în properties vizibile în Admin.
     ========================================================= */

  const ATTR_KEY = "tanna_pairs";

  function getPairs(cart) {
    const raw =
      cart?.attributes?.[ATTR_KEY];

    const arr =
      safeParseJSON(raw, []);

    return Array.isArray(arr)
      ? arr
      : [];
  }

  async function savePairs(pairs) {
    await setCartAttributes({
      [ATTR_KEY]:
        JSON.stringify(
          pairs || []
        ),
    });
  }

  /* =========================================================
     CART DRAWER HELPERS
     ========================================================= */

  function getDrawer() {
    return (
      document.querySelector(
        "cart-drawer#Cart-Drawer"
      ) ||
      document.querySelector(
        "cart-drawer"
      )
    );
  }

  function openDrawerNativeClick() {
    const selectors = [
      ".halo-header__cart a",
      ".halo-cart a",
      ".site-nav__cart a",
      ".header__icon--cart",
      "[aria-controls='cart-drawer']",
      "[data-cart-drawer-open]",
      "[data-open-cart-drawer]",
    ];

    for (const sel of selectors) {
      const el =
        document.querySelector(sel);

      if (el) {
        el.click();
        return true;
      }
    }

    return false;
  }

  function forceNonEmpty(drawer) {
    if (!drawer) return;

    const items =
      drawer.querySelector(
        "cart-drawer-items"
      );

    drawer.classList.remove(
      "is-empty"
    );

    items?.classList.remove(
      "is-empty"
    );

    const emptyContent =
      drawer.querySelector(
        ".cart-drawer__empty-content"
      );

    if (emptyContent) {
      emptyContent.style.display =
        "none";

      emptyContent.setAttribute(
        "hidden",
        "hidden"
      );
    }
  }

  /* =========================================================
     ELLA CART DRAWER HEIGHT FIX

     Tema Ella folosește:
     --cart-drawer-header-height

     Formula este aceeași identificată în global.js:
       drawer header
       + previewCartMessage
       + drawer footer
       + 20px

     După refresh-ul nostru AJAX, Ella nu recalculează
     întotdeauna această variabilă.
     ========================================================= */

  function recalculateEllaDrawerHeight(
    drawer
  ) {
    if (!drawer) return;

    const cartDrawerHeader =
      drawer.querySelector(
        ".drawer__header"
      );

    const cartDrawerMessage =
      drawer.querySelector(
        ".previewCartMessage"
      );

    const cartDrawerFooter =
      drawer.querySelector(
        ".drawer__footer"
      );

    if (
      !cartDrawerHeader ||
      !cartDrawerMessage ||
      !cartDrawerFooter
    ) {
      return;
    }

    const cartDrawerHeaderHeight =
      cartDrawerHeader.offsetHeight +
      cartDrawerMessage.offsetHeight +
      cartDrawerFooter.offsetHeight;

    const setHeight =
      cartDrawerHeaderHeight + 20;

    drawer.style.setProperty(
      "--cart-drawer-header-height",
      `${setHeight}px`
    );
  }

  /* =========================================================
     FULL REFRESH DRAWER
     ========================================================= */

  let refreshLock = false;

  async function refreshDrawerFullOnce() {
    if (refreshLock) {
      return false;
    }

    refreshLock = true;

    try {
      const drawer =
        getDrawer();

      if (!drawer) {
        return false;
      }

      const base =
        location.href.split("?")[0];

      const res =
        await fetch(
          `${base}?section_id=cart-drawer`,
          {
            headers: {
              Accept: "text/html",
            },

            cache: "no-store",
          }
        );

      if (!res.ok) {
        return false;
      }

      const html =
        await res.text();

      const doc =
        new DOMParser()
          .parseFromString(
            html,
            "text/html"
          );

      const incomingDrawer =
        doc.querySelector(
          "cart-drawer#Cart-Drawer"
        ) ||
        doc.querySelector(
          "cart-drawer"
        );

      if (!incomingDrawer) {
        return false;
      }

      const curMain =
        drawer.querySelector(
          "#CartDrawer"
        );

      const incMain =
        incomingDrawer.querySelector(
          "#CartDrawer"
        );

      if (
        curMain &&
        incMain
      ) {
        curMain.innerHTML =
          incMain.innerHTML;
      }

      const curItems =
        drawer.querySelector(
          "cart-drawer-items"
        );

      const incItems =
        incomingDrawer.querySelector(
          "cart-drawer-items"
        );

      if (
        curItems &&
        incItems
      ) {
        curItems.innerHTML =
          incItems.innerHTML;
      }

      /*
       * IMPORTANT:
       * după înlocuirea conținutului,
       * refacem calculul nativ Ella.
       */

      recalculateEllaDrawerHeight(
        drawer
      );

      const cart =
        await getCart()
          .catch(
            () => null
          );

      if (
        (cart?.item_count || 0) >
        0
      ) {
        forceNonEmpty(
          drawer
        );
      }

      return true;

    } catch (e) {
      console.warn(
        "[Tanna V37.3] refreshDrawerFullOnce failed:",
        e
      );

      return false;

    } finally {
      refreshLock = false;
    }
  }

  /* =========================================================
     CLEANUP PERECHI

     IMPORTANT V37.3:

     Returnează TRUE doar dacă scriptul a trebuit
     efectiv să șteargă automat unul dintre cele două
     produse ale perechii.

     Exemple TRUE:
       - clientul șterge rucsacul
         -> scriptul șterge personalizarea

       - clientul șterge personalizarea
         -> scriptul șterge rucsacul

     Exemple FALSE:
       - clientul șterge un produs normal
       - schimbă cantitatea unui produs normal
       - perechea este intactă
       - curățăm doar metadata veche
     ========================================================= */

  let cleanupRunning = false;

  async function cleanupOrphanAddonsOnce() {
    if (cleanupRunning) {
      return false;
    }

    cleanupRunning = true;

    let didAutoDeletePairItem =
      false;

    try {
      const cart =
        await getCart();

      const items =
        cart?.items || [];

      const keys =
        new Set(
          items.map(
            (i) => i.key
          )
        );

      const pairs =
        getPairs(cart);

      if (!pairs.length) {
        return false;
      }

      let changed = false;

      const keep = [];

      for (const p of pairs) {

        const mainExists =
          p?.mainKey &&
          keys.has(
            p.mainKey
          );

        const addonExists =
          p?.addonKey &&
          keys.has(
            p.addonKey
          );

        /* -----------------------------------------------------
           CAZ 1

           Rucsacul a fost șters,
           personalizarea există încă.

           -> ștergem automat personalizarea.
           ----------------------------------------------------- */

        if (
          !mainExists &&
          addonExists
        ) {
          const r =
            await fetch(
              "/cart/change.js",
              {
                method: "POST",

                headers: {
                  "Content-Type":
                    "application/json",

                  Accept:
                    "application/json",
                },

                body:
                  JSON.stringify({
                    id:
                      p.addonKey,

                    quantity:
                      0,
                  }),
              }
            );

          if (r.ok) {
            didAutoDeletePairItem =
              true;
          }

          changed = true;

          continue;
        }

        /* -----------------------------------------------------
           CAZ 2

           Personalizarea a fost ștearsă,
           rucsacul există încă.

           -> ștergem automat rucsacul.

           Astfel nu poate exista un rucsac cu NUME
           fără taxa de personalizare.
           ----------------------------------------------------- */

        if (
          mainExists &&
          !addonExists
        ) {
          const r =
            await fetch(
              "/cart/change.js",
              {
                method: "POST",

                headers: {
                  "Content-Type":
                    "application/json",

                  Accept:
                    "application/json",
                },

                body:
                  JSON.stringify({
                    id:
                      p.mainKey,

                    quantity:
                      0,
                  }),
              }
            );

          if (r.ok) {
            didAutoDeletePairItem =
              true;
          }

          changed = true;

          continue;
        }

        /* -----------------------------------------------------
           CAZ 3

           Rucsacul și personalizarea există.

           -> pereche validă.
           ----------------------------------------------------- */

        if (
          mainExists &&
          addonExists
        ) {
          keep.push(p);

          continue;
        }

        /* -----------------------------------------------------
           CAZ 4

           Ambele au dispărut.

           -> curățăm doar metadata veche.
           -> NU considerăm asta auto-delete.
           -> NU provocăm reload pe /cart.
           ----------------------------------------------------- */

        if (
          !mainExists &&
          !addonExists
        ) {
          changed = true;
        }
      }

      if (changed) {
        await savePairs(
          keep
        );
      }

      return didAutoDeletePairItem;

    } catch (e) {
      console.warn(
        "[Tanna V37.3] cleanup failed:",
        e
      );

      return false;

    } finally {
      cleanupRunning = false;
    }
  }

  /* =========================================================
     DETECTARE PAGINĂ /cart
     ========================================================= */

  function isCartPage() {
    const path =
      window.location.pathname
        .replace(/\/+$/, "");

    return path === "/cart";
  }

  /* =========================================================
     POST CART CLEANUP + REFRESH

     V37.3:

     Dacă suntem pe /cart ȘI cleanup-ul nostru a șters
     automat perechea -> reload o singură dată.

     În rest:
       - nicio schimbare pe /cart
       - drawer-ul continuă flow-ul existent
     ========================================================= */

  let postCartTimer = null;

  function schedulePostCartCleanupAndRefresh() {
    clearTimeout(
      postCartTimer
    );

    postCartTimer =
      setTimeout(
        async () => {

          const didAutoDeletePairItem =
            await cleanupOrphanAddonsOnce();

          /*
           * FIX PAGINA /cart
           *
           * Reload DOAR dacă scriptul nostru
           * a șters automat produsul pereche.
           *
           * Nu se execută pentru:
           * - produs normal
           * - quantity change normal
           * - rucsac fără personalizare
           * - alte operațiuni obișnuite
           */

          if (
            isCartPage() &&
            didAutoDeletePairItem
          ) {
            window.location.reload();

            return;
          }

          /*
           * În afara paginii /cart,
           * păstrăm comportamentul drawer-ului.
           */

          const drawer =
            getDrawer();

          if (
            drawer &&
            (
              drawer.classList.contains(
                "open"
              ) ||
              drawer.getAttribute(
                "open"
              ) === "true"
            )
          ) {
            await sleep(120);

            await refreshDrawerFullOnce();

            forceNonEmpty(
              getDrawer()
            );
          }
        },
        220
      );
  }

  /* =========================================================
     UI POLISH
     Păstrat din versiunile anterioare.
     ========================================================= */

  function hideThemePropertiesStrict(
    row
  ) {
    if (!row) return;

    const needles = [
      "Personalizare nume",
      "Taxă personalizare",
    ];

    row
      .querySelectorAll("dt")
      .forEach((dt) => {

        const label =
          (dt.textContent || "")
            .trim()
            .replace(
              /:$/,
              ""
            );

        if (
          needles.includes(
            label
          )
        ) {
          dt.classList.add(
            "tanna-prop-hidden"
          );

          const dd =
            dt.nextElementSibling;

          if (
            dd &&
            dd.tagName ===
              "DD"
          ) {
            dd.classList.add(
              "tanna-prop-hidden"
            );
          }
        }
      });

    row
      .querySelectorAll("li")
      .forEach((li) => {

        const txt =
          (li.textContent || "")
            .trim();

        if (
          needles.some(
            (n) =>
              txt.startsWith(
                n
              )
          )
        ) {
          li.classList.add(
            "tanna-prop-hidden"
          );
        }
      });
  }

  function closestRow(el) {
    return (
      el?.closest(
        ".cart-item, .cart__item, .cart-drawer-item, [data-cart-item], li, tr"
      ) ||
      null
    );
  }

  function hideAddonLineInDrawer(
    drawer
  ) {
    const itemsRoot =
      drawer?.querySelector(
        "cart-drawer-items"
      );

    if (!itemsRoot) return;

    const hits =
      Array.from(
        itemsRoot.querySelectorAll(
          "*"
        )
      ).filter((n) => {

        const t =
          (n.textContent || "")
            .trim();

        return (
          t.includes(
            "Pentru numele"
          ) ||
          t
            .toLowerCase()
            .includes(
              "personalizare nume rucsac"
            )
        );
      });

    hits.forEach((n) => {

      const row =
        closestRow(n);

      if (row) {
        row.classList.add(
          "tanna-addon-hidden"
        );
      }
    });
  }

  async function injectUnderMainOnce(
    drawer
  ) {
    /*
     * Nu injectăm nimic.
     *
     * În Admin / comandă / cart
     * rămâne doar:
     *
     * NUME: ...
     */

    return;
  }

  /* =========================================================
     CART OPERATION HOOKS
     ========================================================= */

  function setupCartOpsHooksOnce() {
    if (
      window.__tannaHooksV373
    ) {
      return;
    }

    window.__tannaHooksV373 =
      true;

    /*
     * Interceptăm operațiunile Shopify:
     *
     * /cart/change
     * /cart/update
     * /cart/clear
     */

    const origFetch =
      window.fetch;

    window.fetch =
      async function (...args) {

        const res =
          await origFetch.apply(
            this,
            args
          );

        try {
          const url =
            String(
              args[0] || ""
            );

          if (
            url.includes(
              "/cart/change"
            ) ||
            url.includes(
              "/cart/update"
            ) ||
            url.includes(
              "/cart/clear"
            )
          ) {
            schedulePostCartCleanupAndRefresh();
          }

        } catch (_) {}

        return res;
      };

    /*
     * CLICK FALLBACK
     *
     * Pentru remove buttons / links.
     */

    document.addEventListener(
      "click",
      (e) => {

        const t =
          e.target;

        const removeBtn =
          t.closest(
            "button[name='remove']"
          ) ||
          t.closest(
            "[data-cart-remove]"
          ) ||
          t.closest(
            "a[href*='/cart/change']"
          ) ||
          t.closest(
            "a[href*='cart/change']"
          ) ||
          t.closest(
            ".cart-remove, .remove, .btn-remove, .cart-item-remove"
          );

        if (removeBtn) {
          setTimeout(
            schedulePostCartCleanupAndRefresh,
            180
          );
        }
      },
      true
    );

    /*
     * QUANTITY FALLBACK
     *
     * IMPORTANT:
     * modificarea cantității poate declanșa cleanup,
     * dar NU produce reload pe /cart decât dacă
     * cleanup-ul chiar șterge automat perechea.
     */

    document.addEventListener(
      "change",
      (e) => {

        const el =
          e.target;

        if (
          el &&
          el.matches &&
          el.matches(
            'input[name^="updates["], input.quantity__input, input[name="quantity"]'
          )
        ) {
          setTimeout(
            schedulePostCartCleanupAndRefresh,
            220
          );
        }
      },
      true
    );
  }

  /* =========================================================
     PRODUCT PAGE PERSONALIZATION
     ========================================================= */

  async function initPersonalizare() {
    const box =
      document.querySelector(
        ".tanna-personalizare"
      );

    if (!box) {
      return;
    }

    const form =
      document.querySelector(
        'form[action="/cart/add"], form[action^="/cart/add"]'
      );

    if (!form) {
      return;
    }

    const nameInput =
      box.querySelector(
        "#tanna_name"
      );

    const acceptChk =
      box.querySelector(
        "#tanna-accept"
      );

    const acceptWrap =
      box.querySelector(
        "#tanna-accept-wrap"
      );

    const priceEl =
      box.querySelector(
        "#tanna-name-price"
      );

    const nameErrorEl =
      box.querySelector(
        "#tanna-name-error"
      );

    const acceptErrorEl =
      box.querySelector(
        "#tanna-accept-error"
      );

    const addonHandle =
      box.dataset.addonHandle ||
      "personalizare-nume-rucsac";

    const pricePerChar =
      Number(
        box.dataset.pricePerChar ||
        3
      );

    const maxChars =
      Number(
        box.dataset.maxChars ||
        20
      );

    const getName = () =>
      nameInput?.value || "";

    const setNameError =
      (msg) => {

        if (!nameErrorEl) {
          return;
        }

        nameErrorEl.style.display =
          msg
            ? "block"
            : "none";

        if (msg) {
          nameErrorEl.textContent =
            msg;
        }
      };

    const setAcceptError =
      (show, msg) => {

        if (!acceptErrorEl) {
          return;
        }

        acceptErrorEl.style.display =
          show
            ? "block"
            : "none";

        if (msg) {
          acceptErrorEl.textContent =
            msg;
        }
      };

    const shakeAccept =
      () => {

        if (!acceptWrap) {
          return;
        }

        acceptWrap.classList.add(
          "tanna-invalid"
        );

        acceptWrap.classList.remove(
          "tanna-shake"
        );

        void acceptWrap.offsetWidth;

        acceptWrap.classList.add(
          "tanna-shake"
        );

        setTimeout(
          () =>
            acceptWrap.classList.remove(
              "tanna-shake"
            ),
          450
        );
      };

    /* =======================================================
       NAME UI + PRICE
       ======================================================= */

    const updateUI =
      () => {

        let name =
          getName()
            .replace(
              /\s+/g,
              " "
            )
            .replace(
              /^\s+/,
              ""
            )
            .slice(
              0,
              maxChars
            );

        if (
          nameInput &&
          name !==
            nameInput.value
        ) {
          nameInput.value =
            name;
        }

        const len =
          name.length;

        const cost =
          len > 0
            ? len *
              pricePerChar
            : 0;

        if (priceEl) {
          priceEl.innerHTML =
            `Cost personalizare: <strong>${cost} lei</strong>`;
        }

        if (len === 0) {
          return setNameError(
            ""
          );
        }

        if (
          !NAME_REGEX.test(
            name
          )
        ) {
          return setNameError(
            "Doar litere A–Z și cifre 0–9 (fără diacritice sau simboluri)."
          );
        }

        setNameError("");
      };

    nameInput?.addEventListener(
      "input",
      updateUI
    );

    acceptChk?.addEventListener(
      "change",
      () => {

        if (
          acceptChk.checked
        ) {
          setAcceptError(
            false
          );

          acceptWrap
            ?.classList
            .remove(
              "tanna-invalid"
            );
        }
      }
    );

    updateUI();

    /* =======================================================
       MAP NAME LENGTH -> ADDON VARIANT
       ======================================================= */

    let addonVariantsByLen =
      {};

    try {
      const res =
        await fetch(
          `/products/${addonHandle}.js`,
          {
            headers: {
              Accept:
                "application/json",
            },

            cache:
              "no-store",
          }
        );

      const addon =
        await res.json();

      (addon.variants || [])
        .forEach((v) => {

          const t =
            String(
              v.public_title ||
              v.title ||
              ""
            );

          const m1 =
            t.match(
              /(\d+)\s*(?:caract|chars?|lit)/i
            );

          const m2 =
            t.match(
              /(\d+)/
            );

          const m =
            m1 || m2;

          if (m) {
            addonVariantsByLen[
              Number(
                m[1]
              )
            ] = v.id;
          }
        });

    } catch (e) {
      console.warn(
        "[Tanna V37.3] Add-on product not loaded:",
        e
      );
    }

    const getMainVariantIdFromForm =
      () =>
        form.querySelector(
          'input[name="id"]'
        )?.value ||
        null;

    const getQtyFromForm =
      () =>
        Number(
          form.querySelector(
            'input[name="quantity"]'
          )?.value ||
          1
        );

    let submitting = false;

    /* =======================================================
       ADD TO CART
       ======================================================= */

    form.addEventListener(
      "submit",
      async (e) => {

        const name =
          getName()
            .trim()
            .slice(
              0,
              maxChars
            );

        const len =
          name.length;

        /*
         * Fără nume:
         * lăsăm add-ul normal al temei.
         */

        if (len === 0) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (submitting) {
          return;
        }

        submitting =
          true;

        try {
          const beforeCart =
            await getCart()
              .catch(
                () => null
              );

          const beforeKeys =
            new Set(
              (
                beforeCart?.items ||
                []
              ).map(
                (i) => i.key
              )
            );

          const beforeCount =
            beforeCart?.item_count ||
            0;

          const beforeTotal =
            beforeCart?.total_price ||
            0;

          /* ===============================================
             ACCEPT PERSONALIZATION TERMS
             =============================================== */

          if (
            !acceptChk?.checked
          ) {
            setAcceptError(
              true,
              "Te rog bifează că ai citit condițiile pentru produsele personalizate."
            );

            shakeAccept();

            return;
          }

          setAcceptError(
            false
          );

          /* ===============================================
             VALIDATE NAME
             =============================================== */

          if (
            !NAME_REGEX.test(
              name
            )
          ) {
            setNameError(
              "Doar litere A–Z și cifre 0–9 (fără diacritice sau simboluri)."
            );

            nameInput?.focus();

            return;
          }

          setNameError("");

          /* ===============================================
             PRODUCT VARIANTS
             =============================================== */

          const mainVariantId =
            getMainVariantIdFromForm();

          const addonVariantId =
            addonVariantsByLen[
              len
            ];

          const qty =
            getQtyFromForm();

          if (!mainVariantId) {
            setAcceptError(
              true,
              "Nu am putut identifica varianta produsului (id)."
            );

            shakeAccept();

            return;
          }

          if (!addonVariantId) {
            setNameError(
              `Nu există varianta de taxă pentru ${len} caractere (verifică add-on 1–20).`
            );

            return;
          }

          /*
           * IMPORTANT:
           *
           * În Admin / factură / comandă
           * păstrăm DOAR:
           *
           * NUME: ...
           */

          const mainProps = {
            "NUME": name,
          };

          const addonProps = {
            "NUME": name,
          };

          /* ===============================================
             ADD MAIN + ADDON IN SAME REQUEST
             =============================================== */

          const r =
            await fetch(
              "/cart/add.js",
              {
                method:
                  "POST",

                headers: {
                  "Content-Type":
                    "application/json",

                  Accept:
                    "application/json",
                },

                body:
                  JSON.stringify({
                    items: [
                      {
                        id:
                          Number(
                            mainVariantId
                          ),

                        quantity:
                          qty,

                        properties:
                          mainProps,
                      },

                      {
                        id:
                          Number(
                            addonVariantId
                          ),

                        quantity:
                          1,

                        properties:
                          addonProps,
                      },
                    ],
                  }),
              }
            );

          if (!r.ok) {
            let msg =
              "Nu am putut adăuga în coș. Te rog încearcă din nou.";

            try {
              const err =
                await r.json();

              msg =
                err?.description ||
                err?.message ||
                msg;

            } catch (_) {}

            setAcceptError(
              true,
              msg
            );

            shakeAccept();

            return;
          }

          /* ===============================================
             OPEN DRAWER
             =============================================== */

          openDrawerNativeClick();

          await sleep(420);

          const afterCart =
            await getCart()
              .catch(
                () => null
              );

          const afterCount =
            afterCart?.item_count ||
            0;

          const afterTotal =
            afterCart?.total_price ||
            0;

          /* ===============================================
             SAVE MAIN <-> ADDON PAIR
             =============================================== */

          try {
            const newItems =
              (
                afterCart?.items ||
                []
              ).filter(
                (it) =>
                  !beforeKeys.has(
                    it.key
                  )
              );

            const mainItem =
              newItems.find(
                (it) =>
                  Number(
                    it.variant_id
                  ) ===
                  Number(
                    mainVariantId
                  )
              );

            const addonItem =
              newItems.find(
                (it) =>
                  Number(
                    it.variant_id
                  ) ===
                  Number(
                    addonVariantId
                  )
              );

            if (
              mainItem?.key &&
              addonItem?.key
            ) {
              const pairs =
                getPairs(
                  afterCart
                );

              pairs.push({
                mainKey:
                  mainItem.key,

                addonKey:
                  addonItem.key,
              });

              await savePairs(
                pairs
              );
            }

          } catch (_) {
            /*
             * Silent:
             * nu blocăm comanda dacă metadata
             * nu poate fi salvată.
             */
          }

          /* ===============================================
             REFRESH CART DRAWER
             =============================================== */

          const changed =
            afterCount !==
              beforeCount ||
            afterTotal !==
              beforeTotal;

          if (changed) {
            await refreshDrawerFullOnce();
          }

          await sleep(60);

          const d =
            getDrawer();

          forceNonEmpty(d);

        } finally {
          submitting =
            false;
        }
      },
      true
    );
  }

  /* =========================================================
     START
     ========================================================= */

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      setupCartOpsHooksOnce();
      initPersonalizare();
    }
  );
})();